export const enum MutationNames {
  updateShiftReport = 'SHIFT_REPORT_UPDATE_SHIFT_REPORT',
  updateChosenDate = 'SHIFT_REPORT_UPDATE_CHOSEN_DATE',
  updateChosenShiftPeriod = 'SHIFT_REPORT_UPDATE_CHOSEN_SHIFT_PERIOD',
}

export const enum ActionNames {
  getShiftReportByTimestamps = 'SHIFT_REPORT_GET_SHIFT_REPORT_BY_TIMESTAMPS',
}

export const enum GetterNames {
  shiftReport = 'SHIFT_REPORT_SHIFT_REPORT',
  chosenDate = 'SHIFT_REPORT_CHOSEN_DATE',
  chosenShiftPeriod = 'SHIFT_REPORT_CHOSEN_SHIFT_PERIOD',
}
